import { DownOutlined, LogoutOutlined, UserOutlined, DashboardOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, Space } from 'antd'
import type { MenuProps } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Body } from 'src/components/typography'

import * as ROUTES from 'src/constants/routes'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { logout } from 'src/store/slices/account'

export const UserProfile = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const account = useAppSelector((state) => state.account)

  const handleLogout = () => {
    void (async () => {
      try {
        const result = await dispatch(logout())
        if (result.meta.requestStatus === 'fulfilled') {
          void navigate(ROUTES.HOME)
        }
      } catch (error) {
        console.error('Logout error:', error)
      }
    })()
  }

  const handleDashboard = () => {
    void navigate(ROUTES.PRIVATE_HOME)
  }

  const items: MenuProps['items'] = [
    {
      key: 'dashboard',
      label: 'Go to ConnectUp',
      icon: <DashboardOutlined />,
      onClick: handleDashboard,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
      danger: true,
    },
  ]

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Space align="center">
        <Avatar src={account.currentUser?.avatar} icon={<UserOutlined />} size="large" />
        <Body strong>{account.currentUser?.name ?? 'User'}</Body>
        <DownOutlined />
      </Space>
    </Dropdown>
  )
}
